import { useState } from "react";
import { Check, ShoppingBag } from "lucide-react";
import type { ShopProductDetail, ShopVariant } from "@/lib/printify";
import { pickVariantImage } from "@/lib/variant-select";
import { useCart } from "@/lib/useCart";
import styles from "./AddToCartButton.module.css";

interface Props {
  product: ShopProductDetail;
  variant: ShopVariant | null;
}

export default function AddToCartButton({ product, variant }: Props) {
  const { add } = useCart();
  const [added, setAdded] = useState(false);
  const disabled = !variant || !variant.isAvailable;

  function onAdd() {
    if (!variant) return;
    add({
      productId: product.id,
      variantId: variant.id,
      title: product.title,
      variantLabel: variant.label,
      image: pickVariantImage(product, variant),
      unitPrice: variant.price,
    });
    setAdded(true);
    window.setTimeout(() => setAdded(false), 1600);
  }

  return (
    <button type="button" className={styles.button} disabled={disabled} onClick={onAdd}>
      {added ? <Check size={18} /> : <ShoppingBag size={18} />}
      {!variant ? "Unavailable" : !variant.isAvailable ? "Out of stock" : added ? "Added" : "Add to cart"}
    </button>
  );
}
